<template>
    <ol class="breadcrumb align-items-center d-none d-md-flex" v-if="crumbs.length">
        <li
            class="breadcrumb-item text-muted"
            v-for="crumb in crumbs"
            :key="`breadcrumb-${crumb.text}`"
        >
            <router-link
                :to="crumb.path"
                class="btn-link text-muted"
                v-html="crumb.text"
            />
        </li>
    </ol>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            crumbs: []
        };
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler() {
                this.updateCrumbs();
            }
        }
    },
    methods: {
        updateCrumbs() {
            const matchedRoutes = this.$router.currentRoute.matched;

            this.crumbs = [];
            let title = '';

            for (const route of matchedRoutes) {
                if (route.meta?.breadCrumb) {
                    this.crumbs.push({
                        text: route.meta.breadCrumb,
                        path: route.path.length ? route.path : "/"
                    });
                }

                if(route.meta?.title) {
                    title = route.meta.title;
                }
            }

            window.document.title = `${title} | ${window.app.title}`;
        }
    }
});
</script>
